module.exports = __webpack_public_path__ + "static/media/marketing_img.165cce18.png";